<template>
    <div>
        <div class="questionModelTabWrapper d-flex align-items-center">
            <div
                class="questionModelTabItem"
                :class="{ 'active' : currentQuestionModel === 'matching' }"
                @click="currentQuestionModel = 'matching'">
                マッチング問診
            </div>
            <div
                class="questionModelTabItem"
                :class="{ 'active' : currentQuestionModel === 'translation' }"
                @click="currentQuestionModel = 'translation'">
                英語化問診
            </div>
        </div>

        <div
            v-if="currentMedicalCourse !== null"
            class="c-tab-contents">
            <div class="c-tab-contents__tabs">
                <ul v-for="medicalCourse in medicalCourses"
                    class="nav nav-tabs m-tabs-line"
                    role="tablist">

                    <li class="nav-item m-tabs__item">
                        <a
                            role="tab"
                            class="nav-link m-tabs__link"
                            :class="{'active' : medicalCourse.id === currentMedicalCourse.id}"
                            @click="switchTab(medicalCourse)">
                            <div class="tab-medical-course-name">{{ medicalCourse.name }}</div>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="c-tab-contents__body tabContentBody">
                <div class="m-portlet__body">
                    <admin-interview-matching-questions
                        v-show="currentQuestionModel === 'matching'"
                        :medical-course="currentMedicalCourse">
                    </admin-interview-matching-questions>
                    <admin-interview-trans-questions
                        v-show="currentQuestionModel === 'translation'"
                        :medical-course="currentMedicalCourse">
                    </admin-interview-trans-questions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../constants'

export default {
    data: function () {
        return {
            inProgress: false,
            currentQuestionModel: 'matching',
            currentMedicalCourse: null,
            medicalCourses: null,
        }
    },

    created: function () {
        this.fetchMedicalCourses()
    },

    methods: {
        /**
         * 相談科一覧
         */
        fetchMedicalCourses: async function () {
            if (this.inProgress) return
            this.inProgress = true

            this.medicalCourses = null
            const endpoint = constants.admin.medical_courses.endpoint.base

            await axios.get(endpoint)
                .then(({data}) => {
                    this.medicalCourses = data

                    if (!this.currentMedicalCourse) {
                        this.currentMedicalCourse = this.medicalCourses[0]
                    }
                })

            this.inProgress = false
        },

        /**
         * 相談科タブ変更
         * @param {object} medicalCourse
         */
        switchTab: function (medicalCourse) {
            this.currentMedicalCourse = medicalCourse
        },
    },
}
</script>

<style scoped lang="scss">
.tab-medical-course-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
}

a.active {
    .tab-medical-course-name {
        color: #fff;
    }
}

.tabContentBody {
    position: relative;
    padding-bottom: 120px;
}

.questionModelTabWrapper {
    margin-left: 20%;
    
    .questionModelTabItem {
        padding: 0.35rem 0.75rem;
        color: #333;
        font-size: 0.875rem;
        font-weight: bold;
        text-align: center;
        line-height: 1.5;
        background: #DEDEDE;
        border: 1px solid #98A6AC;
        border-radius: 9px 9px 0 0;
        cursor: pointer;

        &.active {
            color: #fff;
            background: #07A0C3;
            border: 1px solid #07A0C3;
            cursor: default;
        }
    }
}
</style>
